import { Pipe, PipeTransform } from '@angular/core';
import { IBlock } from '../../../../models/block.model.i';
import { BlockService } from '../../../navigation/services/block.service';


@Pipe({
    name: 'block'
})
export class BlockPipe implements PipeTransform {

    constructor(private _blockService: BlockService) {

    }

    transform(blockId: string | number, attribute: keyof IBlock, ...args: any[]): any {
        const block = this._blockService.getBlock(blockId);

        if (attribute) {
            return block[attribute];
        }

        return block;
    }

}
